<script>
import BDataTable from './BDataTable';
import lazyLoading from '../../../mixins/lazy-loading-mixin';
import dataMixin from '@/mixins/data-mixin';

export default {
  name: 'LazyLoadingTable',
  components: { BDataTable },
  mixins: [
    lazyLoading(
      self => self.path,
      self => ({ ...self.filter, sort: self.sort })
    ),
    dataMixin('isSaveCallPending', 'transientData.saveCallPending'),
    dataMixin('isApiGetRequestPending', 'transientData.apiGetRequestPending'),
    dataMixin('errorMap', 'transientData.serversideErrors', {})
  ],
  data() {
    return {
      sort: undefined
    };
  },
  props: {
    ...BDataTable.props,
    filter: { type: Object, default: () => {} },
    path: { type: String, required: true },
    statusColumnDefault: { type: Boolean, default: false }
  },
  mounted() {
    this.registerScrollHandler();
    this.reload();
  },
  methods: {
    lazyLoadingSort(items, columns, isDesc) {
      this.sort = (this.filter?.sort ? [this.filter.sort] : [])
        .concat(
          columns.map(
            (column, index) => `${column}:${isDesc[index] ? 'desc' : 'asc'}`
          )
        )
        .join(',');

      return items;
    },
    registerScrollHandler() {
      var target = this.$el.getElementsByClassName('v-data-table__wrapper')[0];
      target.addEventListener('scroll', () => {
        var height = target.scrollHeight - target.offsetHeight;
        var scrollTop = target.scrollTop;
        var distanceToBottom = height - scrollTop;
        if (distanceToBottom < 20 && this.lazyItems.length < this.totalHits) {
          this.loadNextData();
        }
      });
    }
  },
  watch: {
    lazyItems() {
      this.$emit('update:lazy-items', this.lazyItems);
    }
  },
  render(createElement) {
    const customData = {
      props: {
        ...this.$props,
        ...this.$attrs,
        items: this.lazyItems,
        customSort: this.lazyLoadingSort
      },
      on: this.$listeners,
      scopedSlots: this.$scopedSlots
    };

    if (this.statusColumnDefault) {
      customData.props.statusPending =
        this.isApiGetRequestPending || this.isSaveCallPending;
      customData.props.errors = this.errorMap;
    }

    return createElement(BDataTable, customData);
  }
};
</script>
